export const copyText = text => window?.navigator?.clipboard?.writeText(text);
